var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePhotoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 54,
    fill: "#F8F9F9",
    stroke: "#DEE2E5",
    strokeWidth: 2,
    strokeDasharray: "7 7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0857 75.3165C73.4319 64.8514 65.007 57.5264 55.1976 57.5264C45.3962 57.5264 36.977 64.8395 33.3184 75.2911",
    stroke: "#DEE2E5",
    strokeWidth: 3.64,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7376 55C61.0162 55 66.106 49.9102 66.106 43.6316C66.106 37.353 61.0162 32.2632 54.7376 32.2632C48.459 32.2632 43.3691 37.353 43.3691 43.6316C43.3691 49.9102 48.459 55 54.7376 55Z",
    stroke: "#DEE2E5",
    strokeWidth: 3.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhotoPlaceholder);
export default __webpack_public_path__ + "static/media/profile-photo-placeholder.505e61d1c009b6e577742f7712acaf98.svg";
export { ForwardRef as ReactComponent };